import { envVars } from "envvars";
import { openDB } from "idb";
import Cookies from "js-cookie";
import { IndexedDBProxy } from "lib/hooks/useVisitRecorder/types";

const dbPromise = openDB("visit-recording-store", 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains("recording")) {
      const recordingStore = db.createObjectStore("recording", {
        keyPath: "id",
        autoIncrement: true,
      });

      recordingStore.createIndex("by-visitId", "visitId");
    }
  },
});

export const indexedDBProxy: IndexedDBProxy = {
  put: async (visitId: string, value: Blob) => {
    const db = await dbPromise;
    const key = await db.put("recording", { visitId, value });
    return key;
  },
  get: async (visitId: string) => {
    const db = await dbPromise;
    const values = await db.getAllFromIndex("recording", "by-visitId", visitId);
    return values.map((entry) => entry.value);
  },
  del: async (visitId: string) => {
    const db = await dbPromise;

    const values = await db.getAllFromIndex("recording", "by-visitId", visitId);

    for (const key of values) {
      db.delete("recording", key.id);
    }
  },
};

export const createAudioBlobFromBlobs = async (visitId: string) => {
  const blobs = await indexedDBProxy.get(visitId);
  const audioBlob = new Blob(blobs, { type: "audio/webm" });
  return audioBlob;
};

export const createAudioURLFromBlobs = async (visitId: string) => {
  const audioBlob = await createAudioBlobFromBlobs(visitId);
  const audioURL = URL.createObjectURL(audioBlob);
  return audioURL;
};

export const checkJabraConnection = async () => {
  const devices = await navigator.mediaDevices.enumerateDevices();
  const microphones = devices.filter((d) => d.kind === "audioinput");
  const jabra = microphones.find((m) => m.label.startsWith("Jabra"));
  return jabra ? true : false;
};

export const recordingOfficeIds = [
  "PMWG0", // warszawa gagarina = PMWG -> jedyny gabinet lekarski PMWG0
  "PMWU0", // warszawa umińskiego = PMWU -> jedyny gabinet lekarski = PMWU0
  // "PDWP0", // wrocław pułaskiego = PDWP -> jedyny gabinet lekarski PDWP0
];

export const uploadRecording = async (blob: Blob, visitId: string) => {
  const formData = new FormData();

  formData.append("file", blob);

  const response = await fetch(
    `${envVars.REACT_APP_EDM_URL}/api/recordings/upload/${visitId}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${Cookies.get("JWT")}`,
      },
      body: formData,
    },
  );

  if (!response.ok) {
    throw new Error("Failed to upload recording");
  }

  return response.json();
};
